import { isCapacitorNative } from 'Utils/Constants';
import { isMuseFlowAudioPluginAvailable } from 'Utils/MuseFlowAudioPlugin';
import ITimeKeeper from './ITimeKeeper';
import TimeKeeper from './TimeKeeper';
import NativeTimeKeeper from './NativeTimeKeeper';

export function createTimeKeeper(): ITimeKeeper {
  if (isCapacitorNative() && isMuseFlowAudioPluginAvailable()) {
    return new NativeTimeKeeper();
  }
  return new TimeKeeper();
}

export function isNativeTimeKeeper(tk: ITimeKeeper): tk is NativeTimeKeeper {
  return tk instanceof NativeTimeKeeper;
}
